import Vue from "vue";

export class Cgnat {
    /**
     *
     * @return {Promise}
     */
    static geral(json) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get(
                    "cgnat?mac=" +
                        json.mac +
                        "&usuario=" +
                        json.usuario +
                        "&ip=" +
                        json.ip +
                        "&data_inicial=" +
                        json.data_inicial +
                        "&data_final=" +
                        json.data_final
                )
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}